// Package imports:
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight} from '@fortawesome/pro-regular-svg-icons';
import { faFilePdf, faFileImage } from '@fortawesome/pro-solid-svg-icons';
// Component imports:
import Button from '../../ui-elements/Button/Button';
import Link from '../../ui-elements/Link/Link';
import TextImageBlock from '../TextImageBlock/TextImageBlock';
import HeadSection from '../../ui-elements/HeadSection/HeadSection';

const About: React.FC = () => {
    return (
        <div className='main KCL_about-page'>
            <div className="main__inner-fluid grid-items">
                <div className="shell">
                    <HeadSection
                        title="Um Kelduna"
                        description={
                            <p>Keldan ehf. er þjónustufyrirtæki í fararbroddi í upplýsingamiðlun, sem veitir aðgang að öllum helstu skrám sem reknar eru af opinberum aðilum á Íslandi.</p>
                        }
                        actions={
                            <Button
                                buttonType="primary"
                                size="lg"
                                anchorProps={{
                                    href: '/Askrift'
                                }}
                            >
                                Komdu í áskrift
                            </Button>
                        }
                        textAlign='center'
                    />

                    <div className="section__body">
                        <TextImageBlock
                            imgSrc="https://cdn.livemarketdata.com/KeldanImages/kodikeldan.jpg"
                            imgSide="right"
                        >
                            <h2 id="About_KeldanAndKodi">Keldan og Kóði</h2>
                            <div className="text-image-block__entry">
                                <p>Keldan var stofnuð haustið 2009 en Kóði ehf. keypti rekstur hennar árið 2013.</p>
                                <p>Kóði stendur að baki KODIAK viðskiptakerfanna, Hluthafaskrá.is, IPO.is og Live Market Data ásamt því að reka Kelduna.</p>
                                <p>Vöruframboð Kóða er sífellt að aukast en áherslan er alltaf á að gera fjármálakerfið skilvirkara.</p>
                            </div>
                            <Link url="https://kodi.is" targetBlank linkSize='16'>
                                <FontAwesomeIcon icon={faAngleRight} />
                                {"Fara á vef Kóða ehf."}
                            </Link>
                        </TextImageBlock>

                        <div className="text-image-block-list">
                            <TextImageBlock
                                imgSide="right"
                            >
                                <h2 id="About_KeldanProducts">Vörur frá Keldunni</h2>
                                <div className="text-image-block__entry">
                                    <p>
                                        Keldan á og rekur Keldan App Premium þar sem notandi getur keypt áskrift og fengið rauntímagögn, og Vaktarinn.is, sem er greiningartól sem býður upp á vöktun 
                                        og greiningu á þeim leitarorðum sem notandi kýs að vakta.
                                    </p>
                                </div>
                                <div className="text-image-block__buttons">
                                    <Button
                                        buttonType="secondary"
                                        size="lg"
                                        anchorProps={{
                                            href: '/Keldan-App'
                                        }}
                                    >
                                        Keldan App
                                    </Button>
                                    <Button
                                        buttonType="secondary"
                                        size="lg"
                                        anchorProps={{
                                            href: '/Vaktarinn'
                                        }}
                                    >
                                        Vaktarinn.is
                                    </Button>
                                </div>
                            </TextImageBlock>

                            <TextImageBlock>
                                <h2 id="About_ExcellentCompanies">Fyrirmyndarfyrirtæki í rekstri</h2>
                                <div className="text-image-block__entry">
                                    <p>Keldan, í samstarfi við Viðskiptablaðið, tekur saman lista á hverju rekstrarári yfir þau fyrirtæki sem teljast til fyrirmyndar í rekstri.</p>
                                    <p>Listinn hefur verið tekinn saman síðan árið 2017 og hafa mörg hundruð fyrirtækja hlotið viðurkenninguna.</p>
                                </div>
                                <div className="text-image-block__buttons">
                                    <Button
                                        buttonType="secondary"
                                        size="lg"
                                        anchorProps={{
                                            href: '/Listar/Fyrirmyndarfyrirtaeki'
                                        }}
                                    >
                                        Nánar um Fyrirmyndarfyrirtæki
                                    </Button>
                                </div>
                            </TextImageBlock>
                        </div>
                    </div>
                </div>
                <div className="section section--gray section--measures">
                    <div className="shell">
                        <div className="section__inner">
                            <div className="section__head">
                                <h2 id="About_KeldanLogos">Merki Keldunnar</h2>
                                <p>
                                    Hér fæst merki Keldunnar í vektor grafík fyrir prent og PNG fyrir skjámiðla. Sjá einnig um notkun merkisins í hönnunarstaðli Keldunnar.
                                </p>
                                <Link url="https://cdn.livemarketdata.com/KeldanLogos/Um_notkun_merkis_Keldunnar.pdf" targetBlank linkSize='15'>
                                    <FontAwesomeIcon icon={faFilePdf} />
                                    {"Hönnunarstaðall Keldunnar"}
                                </Link>
                            </div>

                            <div className="section__body">
                                <div className="section__group">
                                    <h4>Fyrir prent</h4>
                                    <ul className="list-files">
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_Colored_DarkBg.pdf" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFilePdf} />
                                                {"Merki Keldunnar í lit fyrir dökkan bakgrunn"}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_Colored_LightBg.pdf" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFilePdf} />
                                                {"Merki Keldunnar í lit fyrir ljósan bakgrunn"}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_Black.pdf" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFilePdf} />
                                                {"Merki Keldunnar í svörtu"}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_White.pdf" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFilePdf} />
                                                {"Merki Keldunnar í hvítu"}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                <div className="section__group">
                                    <h4>Fyrir skjámiðla</h4>
                                    <ul className="list-files">
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_Colored_DarkBg.png" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFileImage} />
                                                {"Merki Keldunnar í lit fyrir dökkan bakgrunn"}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_Colored_LightBg.png" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFileImage} />
                                                {"Merki Keldunnar í lit fyrir ljósan bakgrunn"}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_Black.png" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFileImage} />
                                                {"Merki Keldunnar í svörtu"}
                                            </Link>
                                        </li>
                                        <li>
                                            <Link url="https://cdn.livemarketdata.com/KeldanLogos/KeldanLogo_White.png" targetBlank linkSize='15'>
                                                <FontAwesomeIcon icon={faFileImage} />
                                                {"Merki Keldunnar í hvítu"}
                                            </Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default About;